export default {
  name: "Example"
};